<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="mx-auto col-lg-9 col-12">
        <div class="mt-4 card card-body">
          <Form 
          titlePage="New Indicator Pricing"
          subtitlePage="Create new Indicator Pricing"
          submitButtonName="Create Pricing"
          :onSubmit="onSubmit"
          :recordProps="record" />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./Form.vue";
import PricingsService from "@/services/pricings.service.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const toastId = ref('');


export default {
  name: "PricingNew",
  components: {
    Form
  },

  data() {
    return {
      record: {},
    };
  },
  methods: {
    showLoading(){
      toastId.value = toast.loading('Please wait...');
    },
    showSuccess(){
      toast.update(toastId.value, {
        render: "Create Successfully",
        closeOnClick: true,
        closeButton: true,
        type: 'success',
        isLoading: false,
        autoClose: 3000
      });
      
      setTimeout(() => {
        this.$router.replace('/pricings/indicators')
      }, 1000);     
    },
    showFailed(e){
      toast.update(toastId.value, {
        render: e,
        closeOnClick: true,
        closeButton: true,
        type: 'error',
        isLoading: false,
        autoClose: 3000
      });
    },
    onSubmit(data){
      this.showLoading()
      data.product_type = 'indicators'

      PricingsService.create(data).then(e => {
        console.log(e)
        this.showSuccess()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });

    }
  }
};
</script>
